import { StaticImage } from "gatsby-plugin-image";
import React from "react";

export default function OverviewTitle() {
  return (
    <div className="about-mlp overviewTitle-container" id="overview">
      <div className="overview-title">
        <p>
          Everything that we do at Kraftshala is designed to get you a marketing
          job of ₹4.5L or more. More than 2000+ folks have gotten placed at a{" "}
          <span className="gray-text">CTC of 4.5-9LPA</span>
        </p>
        <StaticImage
          src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y1t7m1t5vrsy.webp"
          alt="underline"
          className="y-underline-mlp"
        />
      </div>
    </div>
  );
}
